import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
	GET_ADMIN_ANALYTICS,
	SG_GET_ADMIN_ANALYTICS,
	FETCH_ADMIN_ANALYTIC,
	SG_FETCH_ADMIN_ANALYTIC,
	ADD_ADMIN_ANALYTIC,
	SG_ADD_ADMIN_ANALYTIC,
	EDIT_ADMIN_ANALYTIC,
	SG_EDIT_ADMIN_ANALYTIC,
	DELETE_ADMIN_ANALYTIC,
	SG_DELETE_ADMIN_ANALYTIC,
} from "constants/actions";

/* Admin Analytics */

function* loadAnalytics(action) {
	try {
		const json = yield call(api.GET_APV2_ANALYTICS, action.payload);
		yield put({ type: GET_ADMIN_ANALYTICS, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* analyticsLoad() {
	yield takeLatest(SG_GET_ADMIN_ANALYTICS, loadAnalytics);
}

function* fetchAnalytic(action) {
	try {
		const json = yield call(api.FETCH_APV2_ANALYTIC, action.payload);
		yield put({ type: FETCH_ADMIN_ANALYTIC, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* analyticFetch() {
	yield takeLatest(SG_FETCH_ADMIN_ANALYTIC, fetchAnalytic);
}

function* addAnalytic(action) {
	try {
		const json = yield call(api.ADD_APV2_ANALYTIC, action.payload);
		yield put({ type: ADD_ADMIN_ANALYTIC, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* analyticAdd() {
	yield takeLatest(SG_ADD_ADMIN_ANALYTIC, addAnalytic);
}

function* editAnalytic(action) {
	try {
		const json = yield call(api.EDIT_APV2_ANALYTIC, action.payload);
		yield put({ type: EDIT_ADMIN_ANALYTIC, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* analyticEdit() {
	yield takeLatest(SG_EDIT_ADMIN_ANALYTIC, editAnalytic);
}

function* deleteAnalytic(action) {
	try {
		const json = yield call(api.DELETE_APV2_ANALYTIC, action.payload);
		yield put({ type: DELETE_ADMIN_ANALYTIC, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* analyticDelete() {
	yield takeLatest(SG_DELETE_ADMIN_ANALYTIC, deleteAnalytic);
}

export default function* index() {
	yield all([
		analyticsLoad(),
		analyticFetch(),
		analyticAdd(),
		analyticEdit(),
		analyticDelete(),
	]);
}

